export default __webpack_public_path__ + "static/media/solteiroduplo_7.1c3c99f9.jpg";